import React, { useRef, useState, useContext, useEffect, useMemo, createRef } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { OnTheMenuDataContext } from '../../context-api/OnTheMenuDataProvider';
import { StoreHeaderDataContext } from '../../context-api/StoreHeaderDataProvider';
import { CheckoutDataContext } from '../../context-api/CheckoutDataProvider';
import { Cart, EmptyCart } from '../../composed/cart/Cart';
import { CartMini } from '../../composed/cart/CartMini';
import RestaurantMenuDesktop from './../storemenu/RestaurantMenu/RestaurantMenuDesktop';
import Kitchentitle from '../../composed/storetitle/storetitle';
import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper';
import { getUrlParams, getUrlPath, getUrlFullPath, removeParamFromUrl } from '../../global/getUrl';
import AlertDialog from '../../atomic/Dialog/Dialog';
import { localStorageKeys } from '../../global/constants';
// import ProductCard from '../../atomic/ProductCard';
import {
  ProductCardSkeleton,
  ButtonTabSkeleton,
} from '../../composed/ProductCard/ProductCardSkeleton';
import PageBase from '../../composed/pagebase/pagebase';
import CartSkeleton from './../../composed/cart/CartSkeleton';
import { Error404 } from '../../composed/Error404/Error404';
import {
  STORE_CLOSED_SHORT_TIME,
  STORE_NOT_FOUND_404,
  PRODUCT_NOT_FOUND_404,
} from '../../global/assets/Icons';
import Transition from './../../transition';
import RestaurantMenuMobile from './RestaurantMenu/RestaurantMenuMobile';
import RestaurantMenuIpad from './RestaurantMenu/RestaurantMenuIpad';
import './StoreMenu.scss';
import CloudKitchenMenuDesktop from './CloudKitchenMenu/CloudKitchenMenuDesktop';
import HomeChefMenuDesktop from './HomeChefMenu/HomeChefMenuDesktop';
import CateringMenuDesktop from './CateringMenu/CateringMenuDesktop';
import CelebrityChefMenuDesktop from './CelebrityChefMenu/CelebrityChefMenuDesktop';
import CloudKitchenMenuMobile from './CloudKitchenMenu/CloudKitchenMenuMobile';
import HomeChefMenuMobile from './HomeChefMenu/HomeChefMenuMobile';
import CateringMenuMobile from './CateringMenu/CateringMenuMobile';
import CelebrityChefMenuMobile from './CelebrityChefMenu/CelebrityChefMenuMobile';
import CloudKitchenMenuIpad from './CloudKitchenMenu/CloudKitchenMenuIpad';
import HomeChefMenuIpad from './HomeChefMenu/HomeChefMenuIpad';
import CateringMenuIpad from './CateringMenu/CateringMenuIpad';
import CelebrityChefMenuIpad from './CelebrityChefMenu/CelebrityChefMenuIpad';
import { LoginDataContext } from '../../context-api/LoginDataProvider';
import { GlobalStateDataContext } from '../../context-api/GlobalStateDataProvider';
import PromotionalKitchenMenu from '../../composed/promotionalKitchenMenu/PromotionalKitchenMenu';
const { ZIP_CODE, KITCHEN_NAMES } = localStorageKeys;

const StoreMenu = () => {
  const {
    storeName,
    setStoreName,
    getProductList,
    productsData,
    setProductsData,
    kitchenData,
    setkitchenData,
    storeAccountType,
    setStoreAccountType,
    getKitchenList,
    restaurantList,
    sortedKitchenData,
    setSortedKitchenData,
    cartItems,
    setCartItems,
    promoKicthenAvailable,
    promotionalKitchenList,
    ShowPromotionalKitchen,
  } = useContext(OnTheMenuDataContext);
  const IsItemsInCart =
    cartItems?.mealItems?.length > 0 ||
    cartItems?.nonMealItems?.length > 0 ||
    cartItems?.promotionalItems?.length > 0;
  const { kitchensByZipcode, kitchensByZipcodeResponse, onGetKitchenByZipcodeHandler } =
    useContext(StoreHeaderDataContext) || {};
  const { isLoggedIn, onCustomerInformationApiHandler, customerInfoData } =
    useContext(LoginDataContext);
  const { loading, data, success, errorMessage, noKitchensFound } = customerInfoData;
  const IsStoreMenuPage = getUrlPath().includes('/onthemenu/storemenu');
  const { storename: urlStoreName } = getUrlParams();
  const [open, setOpen] = useState(false);
  const [displayText, setdisplayText] = useState('');
  const [showAgreeButton, setshowAgreeButton] = useState(true);
  const [showDisagreeButton, setshowDisagreeButton] = useState(true);
  const [buttonAgreeLabel, setButtonAgreeLabel] = useState('Okay');
  const [iconForAlert, setIconForAlert] = useState(null);
  const [iconWidth, setIconWidth] = useState('125px');
  const localStorageZipcode = () => localStorage.getItem(ZIP_CODE);
  const localStorageKitchens = () => localStorage.getItem(KITCHEN_NAMES);
  const zipcodeComingFromProduct = productsData.data?.data?.[urlStoreName]?.Geolocation?.zipcode;
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const UrlAndProductKitchenAreSame =
    productsData?.data?.data?.[urlStoreName]?.kitchenName === urlStoreName;
  const ProductCount = productsData?.data?.data?.[urlStoreName]?.product_count === 0;
  const DataKitchenInfo = ProductCount ? null : productsData?.data?.data?.[urlStoreName]; // Sorting kitchen information from /GetProduct API
  const StoreClosedForShortTime = sortedKitchenData?.storeIsClosedForShortTime;
  const promoKtchenName =
    kitchensByZipcodeResponse?.data?.promoKitchenNames?.[0] ||
    promotionalKitchenList?.[0]?.kitchenName;

  const initfunc = async () => {
    if (ShowPromotionalKitchen()) {
      await getProductList({ kitchen_names: [urlStoreName, promoKtchenName] });
      return;
    }
    await getProductList({ kitchen_names: [urlStoreName] });
  };

  const apiCallGetKitchenData = async (urlStoreName) => {
    await getKitchenList([urlStoreName]);
  };

  const apiCallCustomerInfo = async () => {
    await onCustomerInformationApiHandler();
  };

  const onAlertAgree = () => {
    if (StoreClosedForShortTime) {
      removeParamFromUrl('storename');
      setOpen(false);
      navigate('/onthemenu');
    }
  };

  const someThingWentWrong = async (verbage) => {
    if (StoreClosedForShortTime) {
      setdisplayText(verbage);
      setOpen(true);
      setProductsData({});
      setshowDisagreeButton(false);
      setshowAgreeButton(true);
      return;
    }

    setdisplayText(verbage);
    setOpen(true);
    setshowDisagreeButton(false);
    setshowAgreeButton(false);
    setTimeout(() => {
      removeParamFromUrl('storename');
      setOpen(false);
      navigate('/onthemenu');
    }, 7000);
  };

  useEffect(() => {
    if (!urlStoreName && !storeName) {
      navigate('/onthemenu');
      return;
    }
    if (urlStoreName && !storeName) {
      apiCallGetKitchenData(urlStoreName);
    }
    if (urlStoreName && IsStoreMenuPage) {
      initfunc();
    }
    if (isLoggedIn) {
      apiCallCustomerInfo();
    }

    if (kitchensByZipcodeResponse.data === null && kitchensByZipcode.data === null && !isLoggedIn) {
      const setLocalStorage = true;
      onGetKitchenByZipcodeHandler(localStorageZipcode(), setLocalStorage);
    }
  }, []);

  useEffect(() => {
    if (urlStoreName && !storeName) {
      kitchenData?.data?.data?.forEach((data) => {
        setStoreAccountType(data.account_type);
        setStoreName(data.kitchenName);
      });
    }

    // Url store name is not in localstorage ,should be redirect
    if (!localStorageKitchens().split(',').includes(urlStoreName)) {
      const verbageText = `Sorry, restaurant can't deliver to your zipcode. Redirecting to OnTheMenu.`;
      setIconForAlert(STORE_NOT_FOUND_404);
      setIconWidth('250px');
      someThingWentWrong(verbageText);
    }
  }, [kitchenData]);

  useEffect(() => {
    // Check product count should not be === 0
    if (productsData?.data !== null && ProductCount) {
      const verbageText = `Product out of stock. Redirecting to OnTheMenu for more options.`;
      setProductsData({
        errors: null,
        isLoading: false,
        data: null,
      });
      setIconForAlert(PRODUCT_NOT_FOUND_404);
      setIconWidth('250px');
      someThingWentWrong(verbageText);
    }

    if (productsData.errors && productsData.errors === 'There are no products available!') {
      const verbageText = `No products found. Redirecting to OnTheMenu for more options.`;
      setProductsData({
        errors: null,
        isLoading: false,
        data: null,
      });
      setIconForAlert(PRODUCT_NOT_FOUND_404);
      setIconWidth('250px');
      someThingWentWrong(verbageText);
    }
  }, [[JSON.stringify(productsData)]]);

  useEffect(() => {
    // Storing kitchen information from /GetProduct API
    // If you are adding anything to setSortedKitchenData pls add that code on  [ Pdp.jsx, StoreMenu.jsx, PromotionalKitchenMenu.js OntheMenuDataProvider.jsx ]
    if (DataKitchenInfo && DataKitchenInfo !== null && urlStoreName) {
      setSortedKitchenData({
        ...sortedKitchenData,
        kitchenName: DataKitchenInfo?.kitchenName,
        kitchen_id: DataKitchenInfo?._id,
        account_type: DataKitchenInfo?.account_type,
        display_name: DataKitchenInfo?.display_name,
        display_image: DataKitchenInfo?.display_image,
        cuisine: DataKitchenInfo?.cuisine,
        meal_offering: DataKitchenInfo?.meal_offering,
        operation_start_time: DataKitchenInfo?.operation_start_time,
        operation_end_time: DataKitchenInfo?.operation_end_time,
        opening_status: DataKitchenInfo?.opening_status,
        delivery_agreement_fees: DataKitchenInfo?.delivery_agreement_fees,
        address: DataKitchenInfo?.Geolocation?.formattedAddress,
        deliveryPayAsYouGo_fee: DataKitchenInfo?.deliveryPayAsYouGo_fee,
        deliverySubscription_fee: DataKitchenInfo?.deliverySubscription_fee,
        delivery_type_available: DataKitchenInfo?.delivery_type_available,
        freePayAsYouGoDelivery: DataKitchenInfo?.freePayAsYouGoDelivery,
        freePayAsYouGoDelivery_TimeGap: DataKitchenInfo?.freePayAsYouGoDelivery_TimeGap,
        freeSubscriptionDelivery: DataKitchenInfo?.freeSubscriptionDelivery,
        freeSubscriptionDelivery_TimeGap: DataKitchenInfo?.freeSubscriptionDelivery_TimeGap,
        nearestKitchenNames: DataKitchenInfo?.nearestKitchenNames,
        storeIsClosedForShortTime: DataKitchenInfo?.storeIsClosedForShortTime,
        agreedForFreeComboPromo: DataKitchenInfo?.agreedForFreeComboPromo,
        amountRequiredForComboPromo: DataKitchenInfo?.amountRequiredForComboPromo,
        subscriptionMenuAvailable: DataKitchenInfo?.subscriptionMenuAvailable,
        regularMenuAvailable: DataKitchenInfo?.regularMenuAvailable,
        status: DataKitchenInfo?.status,
        delivered_by: DataKitchenInfo?.delivered_by,
        delivery_kitchen_fee: DataKitchenInfo?.delivery_kitchen_fee,
        restrictedDeliveryDay: DataKitchenInfo?.restrictedDeliveryDay,
        restrictedDeliveryStartTime: DataKitchenInfo?.restrictedDeliveryStartTime,
        restrictedDeliveryEndTime: DataKitchenInfo?.restrictedDeliveryEndTime,
        delivery_driver_shortage: DataKitchenInfo?.delivery_driver_shortage,
        pickup_order_promotion: DataKitchenInfo?.pickup_order_promotion,
        Geolocation: DataKitchenInfo?.Geolocation,
        package_plan: DataKitchenInfo?.package_plan,
        dedicated_drivers: DataKitchenInfo?.dedicated_drivers,
      });
    }
  }, [productsData]);

  useEffect(() => {
    if (Object.keys(sortedKitchenData).length > 0 && StoreClosedForShortTime) {
      const verbageText = `Sorry store closed for some time, please visit back later.`;
      setIconForAlert(STORE_CLOSED_SHORT_TIME);
      setButtonAgreeLabel('Redirect to OnTheMenu');
      someThingWentWrong(verbageText);
    }
    return;
  }, [sortedKitchenData]);

  // We should capture this if block errors in new relic
  if (
    productsData.errors === 'Network Error' ||
    kitchensByZipcode.error === 'Network Error' ||
    errorMessage === 'Network Error' ||
    (errorMessage?.success === false &&
      errorMessage?.CustomMessage === 'Something is seriouly wrong,This is last CATCH block')
  ) {
    return <Error404 />;
  }

  if (productsData.isLoading || loading) {
    if (isDesktop) {
      return (
        <PageBase>
          <div className='loading-skeleton-container'>
            <div className='loading-section-1'>
              <ButtonTabSkeleton />
              <div className='loading-product-skeleton-container'>
                {[1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
                  <ProductCardSkeleton key={n} />
                ))}
              </div>
            </div>
            <div className='loading-section-2'>
              <CartSkeleton />
            </div>
          </div>
        </PageBase>
      );
    }
    if (isIpad || isMobile) {
      return (
        <div className='mobile-loading-skeleton-container'>
          <ButtonTabSkeleton />
          <div className='mobile-loading-product-skeleton'>
            {[1, 2, 3, 4].map((n) => (
              <ProductCardSkeleton key={n} />
            ))}
          </div>
        </div>
      );
    }
  }

  if (!productsData?.isLoading && !loading) {
    if (isDesktop) {
      return (
        <PageBase>
          <div className='store-menu-container'>
            <div className='section-1'>
              {ShowPromotionalKitchen() && <PromotionalKitchenMenu />}
              {storeAccountType === 'restaurant' && <RestaurantMenuDesktop />}
              {storeAccountType === 'cloud kitchen' && <CloudKitchenMenuDesktop />}
              {storeAccountType === 'home chef' && <HomeChefMenuDesktop />}
              {storeAccountType === 'catering' && <CateringMenuDesktop />}
              {storeAccountType === 'celebrity chef' && <CelebrityChefMenuDesktop />}
            </div>
            <div className='section-2'>{/* {IsCartItems ? <Cart /> : <EmptyCart />} */}</div>
          </div>
          <AlertDialog
            isLoading={false}
            open={open}
            // setOpen={setOpen}  // when you click any where on screen it will close dialog
            onAgree={onAlertAgree}
            buttonAgreeLabel={buttonAgreeLabel}
            onDisagree={null}
            displayText={displayText}
            showAgreeButton={showAgreeButton}
            showDisagreeButton={showDisagreeButton}
            icon={iconForAlert}
            iconWidth={iconWidth}
          />
          <Outlet />
        </PageBase>
      );
    }
    if (isMobile) {
      return (
        <>
          {storeAccountType === 'restaurant' && <RestaurantMenuMobile />}
          {storeAccountType === 'cloud kitchen' && <CloudKitchenMenuMobile />}
          {storeAccountType === 'home chef' && <HomeChefMenuMobile />}
          {storeAccountType === 'catering' && <CateringMenuMobile />}
          {storeAccountType === 'celebrity chef' && <CelebrityChefMenuMobile />}
          <AlertDialog
            isLoading={false}
            open={open}
            // setOpen={setOpen}
            onAgree={onAlertAgree}
            buttonAgreeLabel={'OnTheMenu'}
            onDisagree={null}
            displayText={displayText}
            showAgreeButton={showAgreeButton}
            showDisagreeButton={showDisagreeButton}
            icon={iconForAlert}
            iconWidth={iconWidth}
          />
        </>
      );
    }
    if (isIpad) {
      return (
        <PageBase>
          <div className='store-menu-ipad-container'>
            <div className='section-1'>
              {ShowPromotionalKitchen() && <PromotionalKitchenMenu />}
              {storeAccountType === 'restaurant' && <RestaurantMenuIpad />}
              {storeAccountType === 'cloud kitchen' && <CloudKitchenMenuIpad />}
              {storeAccountType === 'home chef' && <HomeChefMenuIpad />}
              {storeAccountType === 'catering' && <CateringMenuIpad />}
              {storeAccountType === 'celebrity chef' && <CelebrityChefMenuIpad />}
              <AlertDialog
                isLoading={false}
                open={open}
                // setOpen={setOpen}
                onAgree={onAlertAgree}
                buttonAgreeLabel={buttonAgreeLabel}
                onDisagree={null}
                displayText={displayText}
                showAgreeButton={showAgreeButton}
                showDisagreeButton={showDisagreeButton}
                icon={iconForAlert}
                iconWidth={iconWidth}
              />
            </div>
            {/* <div className='section-2'>
                            {IsCartItems && <CartMini />}
                        </div> */}
          </div>
        </PageBase>
      );
    }
  }
};

export default Transition(StoreMenu);
